export default "__VITE_ASSET__DwPfUh9A__"